module.exports = __webpack_public_path__ + "img/deux-battants.e79413a.svg";